import { render, staticRenderFns } from "./statements-report-details-column.vue?vue&type=template&id=e2d68b0e"
import script from "./statements-report-details-column.vue?vue&type=script&lang=js"
export * from "./statements-report-details-column.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports